<template>
  <section>
    <v-dialog
      v-model="showModal"
      max-width="600px"
    >
      <v-card
        color="#ECEFF1"
      >
        <br>
        <h2 class="title-style">
          <v-icon class="icon-style">
            mdi-pencil
          </v-icon> Create App Module
        </h2>
        <v-card-text>
          <v-form>
            <p class="p-style">
              Please choose the App Module you want to add from the list below.
            </p>
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="moduleType"
                  menu-props="auto"
                  :items="appModulesList"
                  item-value="id"
                  item-text="name"
                  label="App Module Types"
                  dense
                  outlined
                  single-line
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-3"
            @click="showModal = false;"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            color="#FF3700"
            @click="createAppModule()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
      <centre-spinner
        :loading="loading"
      />
    </v-dialog>
  </section>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'CreateAppModule',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        appModulesList: [
          { name: 'Digital Signage', id: 'digital-signage' },
          { name: 'Swift Check-In', id: 'swift-check-in' },
          { name: 'Swift Check-In Projects', id: 'swift-check-in-projects' },
        ],
        moduleType: '',
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      async createAppModule () {
        this.loading = true;
        await this.$store.dispatch('organizations/createAppModule', {
          name: this.moduleType,
        })
          .then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'App Module created successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.loading = false;
            this.showModal = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
::v-deep .input-field-styling .v-label {
  font-weight: bolder;
  color: #37474F;
  font-size: 14px;
}
.p-style {
  font-size: 20px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #546E7A;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 35px;
}
</style>
